import { DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { AffectedItemsTable } from '@retail/calculus/components';
import { useAffectedItems } from '@retail/calculus/context';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { InfoChip, withDialogSuspenseErrorBoundary } from '@retail/components';
import { Dialog } from '@shared/components';
import { useMemo } from 'react';

interface Props {
  open: boolean;
  supplierNumber: number;
  conditionIds: number[];
  onClose: () => void;
}

function AffectedItemsDialog({ open, supplierNumber, conditionIds, onClose }: Props) {
  const t = useCalculusTFunction();
  const { assortmentId } = useSelectedOrgUnit();

  const { items, isLoading } = useAffectedItems({
    assortmentId,
    supplierNumber,
    conditionIds,
  });

  const baseItems = useMemo(() => items.map((item) => item.base), [items]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          height: '100%',
        },
      }}
    >
      <DialogTitle>{t('calculus.itemsAffected.priceList')}</DialogTitle>
      <DialogContent className="padding-0">
        <Stack height="100%">
          <Stack flexDirection="row" px={3} gap={1} alignItems="center">
            <Typography variant="subtitle1">
              {t('calculus.itemsAffected.affectedItems')}:
            </Typography>
            <InfoChip label={items.length} />
          </Stack>

          <AffectedItemsTable items={baseItems} loading={isLoading} />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
export default withDialogSuspenseErrorBoundary(AffectedItemsDialog);
